import {Component} from '@angular/core';
import {ShopGenerateInterface} from "../checkout/interfaces/shop-generate.interface";

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent {
    showImageGeneration = false;
    shopGenerationInfo: ShopGenerateInterface;


    onShowImagesGeneration(info: ShopGenerateInterface): void {
        this.shopGenerationInfo = info
        this.showImageGeneration = true;
    }

    hideImagesGeneration(): void {
      this.shopGenerationInfo = undefined;
      this.showImageGeneration = false;
    }
}
